<template>
    <div class="designeroption" :data-designer-component-id="component_id">
        <h3>{{ title }}</h3>
        <div :class="['stylesoption designer-question-tiled-layout', range_question_columns]">
            <div v-for="range in ranges" @click.prevent="range.id !== 30 ? switch_range(range.id) : ''" :class="['tile', target == range.id ? 'active' : '']">
                <a href="#!">
                    <h3 class="mt-0" v-html="range.name"></h3>
                    <img :src="thumbURL + 'doortype-' + range.thumbnail + '.jpg'" alt="">
                    <span v-html="range.description"></span>
                    <i class="fa fa-check" aria-hidden="true"></i>
                </a>
            </div>
            <!--flexbox hack-->
            <div class="tile-empty"></div><div class="tile-empty"></div><div class="tile-empty"></div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionDoorRange from "../DesignerQuestionDoorRange.vue";

    export default {
        mixins: [
            DesignerQuestionDoorRange
        ],
        computed: {
            thumbURL(){
                return '/images/britdoors/';
            },
        },
    }
</script>
